import { render, staticRenderFns } from "./SyncStepErrors.vue?vue&type=template&id=4ff7533a"
import script from "./SyncStepErrors.vue?vue&type=script&lang=js"
export * from "./SyncStepErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports